import { Component, Input, OnInit } from '@angular/core';
import { DuctProperties } from '../../../state/edge.model';

@Component({
  selector: '[app-edge-duct-diagram-duct]',
  templateUrl: './edge-duct-diagram-duct.component.html'
})
export class EdgeDuctDiagramDuctComponent implements OnInit {

  @Input()
  duct: DuctProperties;

  constructor() { }

  ngOnInit(): void { }

}

